import { FooterDesktop } from "./FooterDesktop";

export { FooterDesktop };
